import type { ReactNode } from "react";
import { Box, Column } from "@hightouch/htui";

type LandingLayoutProps = {
  /** The heading, chat composer, and quick prompts. */
  children: ReactNode;
  /** Pinned under the composer at the bottom of the page. */
  footer: ReactNode;
};

// Shared by the landing page and its Suspense skeleton, so it stays free of
// data hooks to keep the page chunk out of the main bundle.
export function LandingLayout({ children, footer }: LandingLayoutProps) {
  return (
    <Column flex={1} minHeight={0} overflowY="auto" p={4} align="center">
      <Column
        // Grows to push the footer to the bottom, but never shrinks below its content, so short viewports scroll.
        flex="1 0 auto"
        align="center"
        justify="center"
        gap={10}
        width="100%"
        py={10}
      >
        {children}
      </Column>
      <Box width="100%" px={6} pb={6}>
        {footer}
      </Box>
    </Column>
  );
}
